import AiDocumentUploadModal from './AiDocumentUploadModal'

export default AiDocumentUploadModal
